import { useSelector } from 'react-redux'
import { selectIsAuthenticated, selectUser, selectPermissions } from '@/store/authSlice'

export const useAuth = () => {
    const isAuthenticated = useSelector(selectIsAuthenticated)
    const user = useSelector(selectUser)
    const permissions = useSelector(selectPermissions)

    const hasPermission = (permission) => {
        if (user.role === 'admin') return true
        return permissions.includes(permission)
    }

    const isAdmin = user.role === 'admin'
    const isSupervisor = user.role === 'supervisor' || isAdmin

    return { isAuthenticated, user, permissions, hasPermission, isAdmin, isSupervisor }
}
